import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './ModelStatusBanner.css';

function ModelStatusBanner({ modelAvailable, cloudFallback, source }) {
  const [mounted, setMounted] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem('model_banner_dismissed') === '1'; }
    catch { return false; }
  });

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || dismissed) {
    return null;
  }

  // If AI is available (either local or cloud), don't show warning banner
  if (modelAvailable) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
    try { sessionStorage.setItem('model_banner_dismissed', '1'); }
    catch {}
  };

  // AI is not available at all (no local model, no cloud fallback)
  const bannerContent = (
    <div className="model-status-banner">
      <div className="model-status-message">
        AI Powered Functionality is Currently Offline, Check Back Later
      </div>
      <button
        className="model-status-dismiss"
        onClick={handleDismiss}
        aria-label="Dismiss"
      >
        x
      </button>
    </div>
  );

  return createPortal(bannerContent, document.body);
}

export default ModelStatusBanner;
